import MaterialBox from "../../../../../__snowpack__/pkg/@mui/material/Box.js";
import styled from "styled-components";
import {BreadcrumbsContainer} from "../../../../components/molecules/breadcrumbs/breadcrumbs.styles.js";
export const PropertyListContainer = styled(MaterialBox).withConfig({
  displayName: "merge-units-liststyles__PropertyListContainer",
  componentId: "sc-iogcst-0"
})(["", " ", "{", "}left:", ";"], {
  display: "flex",
  flexDirection: "column"
}, BreadcrumbsContainer, {
  marginBottom: "1.5rem"
}, ({
  position
}) => position && `${position}px`);
export const PageActions = styled(MaterialBox).withConfig({
  displayName: "merge-units-liststyles__PageActions",
  componentId: "sc-iogcst-1"
})(["", ""], {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "2rem"
});
